var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((10),function(item){return _c('foldable-bar',{key:item},[_c('h1',{attrs:{"slot":"main"},slot:"main"},[_vm._v("123")]),_c('h1',{attrs:{"slot":"more"},slot:"more"},[_vm._v("21")])])}))}
var staticRenderFns = []

export { render, staticRenderFns }